<!--人文美育-视频库管理-->
<template>
    <div class="studio_nav_content" >
        <!--五馆合一-->
        <div class="page-mode" v-show="showMode==='page'">
            <div class="m-row">
                <img class="m-card cursor" @click="viewMuseum('ydtz')" alt="恒岳·阅读拓展馆" src="../../assets/museum/mu1.png" />
                <img class="m-card cursor" @click="viewMuseum('kjys')" alt="恒岳·科技艺术馆" src="../../assets/museum/mu2.png" />
            </div>
            <div class="m-row">
                <img class="m-card cursor" @click="viewMuseum('fywh')" alt="恒岳·非遗文化馆" src="../../assets/museum/mu3.png" />
                <img class="m-card cursor" @click="viewMuseum('ldsj')" alt="恒岳·劳动实践营" src="../../assets/museum/mu4.png" />
                <img class="m-card cursor" @click="viewMuseum('zryx')" alt="恒岳·自然研学馆" src="../../assets/museum/mu5.png" />
            </div>
        </div>
        <!--五馆阅读拓展-->
        <div class="museum-mode" v-show="showMode==='museum-ydtz'">
            <read-extension-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆科技艺术-->
        <div class="museum-mode" v-show="showMode==='museum-kjys'">
            <tech-art-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆非遗文化-->
        <div class="museum-mode" v-show="showMode==='museum-fywh'">
            <intangible-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆劳动实践-->
        <div class="museum-mode" v-show="showMode==='museum-ldsj'">
            <labor-practice-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆自然研学-->
        <div class="museum-mode" v-show="showMode==='museum-zryx'">
            <nature-study-museum @child-back-museum="childBackMuseum" />
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import readExtensionMuseum from "@/components/newMuseum/readExtensionMuseum.vue";
import techArtMuseum from "@/components/newMuseum/techArtMuseum.vue";
import intangibleMuseum from "@/components/newMuseum/intangibleMuseum.vue";
import laborPracticeMuseum from "@/components/newMuseum/laborPracticeMuseum.vue";
import natureStudyMuseum from "@/components/newMuseum/natureStudyMuseum.vue";

export default {
    name: "newFiveMuseum",
    components: {readExtensionMuseum,techArtMuseum,intangibleMuseum,natureStudyMuseum,laborPracticeMuseum},
    data() {
        return {
            showMode:'page',
            museumMode:'museum-',
            serviceUrl,

        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted(){},
    methods: {
        /*查看五馆*/
        viewMuseum(item){
            this.showMode = this.museumMode +item;
            this.$emit('change-mode',this.showMode, 30);
        },
        childBackMuseum(val){
            this.showMode = val;
        }
    }
}

</script>

<style lang="scss" scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
/*五馆首页：透明背景适配父页面，卡片一屏内展示*/
.page-mode{
    width: 100%;
    height: calc(100vh - 178px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px 0;
    border-radius: 28px;
}
.m-row{
    flex: 1;
    min-height: 0;
    display: flex;
    justify-content: center;
    gap: 32px;
}
.m-card{
    height: 100%;
    max-width: 45%;
    object-fit: contain;
    transition: transform .2s ease;
}
.m-card:hover{
    transform: translateY(-4px);
}
.museum-mode{
    width: 100%;
    height: auto;
}
</style>
